/**
 * A gravação da revisão do dado pelo painel (E203.F4.C, F-E203.F4-04): leva a versão do documento
 * que o painel mostrava ao abrir; a recusa pela versão (o laudo já assinado, o documento que mudou)
 * vira a frase do painel, e o que a pessoa digitou fica no formulário.
 */
import { ptBR } from '@/i18n/pt-BR';
import {
  registrarRevisaoDoDado,
  RevisaoDoDadoRecusada,
  type PedidoDeRevisaoDoDadoData,
} from '@/lib/revisaoDoDado';

import type { PropsDoConteudo } from './tipos';

const t = ptBR.painelDoDado.recusa;

/** A frase da recusa pela versão; `null` para qualquer outra falha. */
export function fraseDaRecusa(err: unknown): string | null {
  if (!(err instanceof RevisaoDoDadoRecusada)) return null;
  return err.motivo === 'laudo_ja_assinado' ? t.assinado : t.desatualizado;
}

/** Grava a revisão; devolve a frase da recusa pela versão, ou `null` quando gravou. */
export async function gravarRevisao(
  { client, caseId, avaliacaoId }: Pick<PropsDoConteudo, 'client' | 'caseId' | 'avaliacaoId'>,
  pedido: Omit<PedidoDeRevisaoDoDadoData, 'avaliacao_id'>,
): Promise<string | null> {
  const comVersao = avaliacaoId ? { ...pedido, avaliacao_id: avaliacaoId } : pedido;
  try {
    await registrarRevisaoDoDado(client, caseId, comVersao);
    return null;
  } catch (err) {
    const frase = fraseDaRecusa(err);
    if (frase !== null) return frase;
    throw err;
  }
}
